var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalletsStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.25C8.5 14.5596 9.05964 14 9.75 14H45.25C45.9404 14 46.5 14.5596 46.5 15.25C46.5 15.9404 45.9404 16.5 45.25 16.5H42V16.75V21H45.25C45.9404 21 46.5 21.5596 46.5 22.25C46.5 22.9404 45.9404 23.5 45.25 23.5H9.75C9.05964 23.5 8.5 22.9404 8.5 22.25C8.5 21.5596 9.05964 21 9.75 21H13.5L13.5 16.75V16.5H9.75C9.05964 16.5 8.5 15.9404 8.5 15.25ZM39.5 21V16.75V16.5H29V16.75V21H39.5ZM26.5 21H16L16 16.75V16.5H26.5V16.75V21Z",
    fill: "#A6A6B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 29.25C3.5 28.5596 4.05964 28 4.75 28H40.25C40.9404 28 41.5 28.5596 41.5 29.25C41.5 29.9404 40.9404 30.5 40.25 30.5H37V30.75V35H40.25C40.9404 35 41.5 35.5596 41.5 36.25C41.5 36.9404 40.9404 37.5 40.25 37.5H4.75C4.05964 37.5 3.5 36.9404 3.5 36.25C3.5 35.5596 4.05964 35 4.75 35H8.5L8.5 30.75V30.5H4.75C4.05964 30.5 3.5 29.9404 3.5 29.25ZM34.5 35V30.75V30.5H24V30.75V35H34.5ZM21.5 35H11L11 30.75V30.5H21.5V30.75V35Z",
    fill: "#CECED4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.25C0.5 0.559644 1.05964 0 1.75 0H37.25C37.9404 0 38.5 0.559644 38.5 1.25C38.5 1.94036 37.9404 2.5 37.25 2.5H34V2.75V7H37.25C37.9404 7 38.5 7.55964 38.5 8.25C38.5 8.94036 37.9404 9.5 37.25 9.5H1.75C1.05964 9.5 0.5 8.94036 0.5 8.25C0.5 7.55964 1.05964 7 1.75 7H5.5L5.5 2.75V2.5H1.75C1.05964 2.5 0.5 1.94036 0.5 1.25ZM31.5 7V2.75V2.5H21V2.75V7H31.5ZM18.5 7H8L8 2.75V2.5H18.5V2.75V7Z",
    fill: "#CECED4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalletsStack);
export default __webpack_public_path__ + "static/media/PalletsStack.96c5aba8466da6f9eff7518d4e9171a8.svg";
export { ForwardRef as ReactComponent };